module.exports = __webpack_public_path__ + "img/paidakia.ca85e8e2.jpg";